<template>
    <div :style="{ 'background' : data.impairedRegime ? '#ffffff' : '#f2f2f2' }" class="outer flex-col">
        <div :style="{ 'background' : '#ffffff', 'color' : data.impairedRegime ? '#000000' : '#333333'}" class="foot-top flex-col">
            <h3 v-if="lang === 'ru'">Задать анонимный вопрос</h3>
            <h3 v-if="lang === 'kk'">Анонимді сұрақ қою</h3>
            <span v-if="lang === 'ru'">Ты можешь задать любой интересующий тебя вопрос, а мы обязательно ответим на него</span>
            <span v-if="lang === 'kk'">"Кез келген сұрақты қоя аласың, міндетті түрде жауап қатамыз"</span>
            <div @click="$router.push({ name: 'ask-question' })" :style="{ 'background' : data.impairedRegime ? 'rgba(0,0,0,0.6)' : '#568357' }" class="q-box flex-col">
                <div class="out-box">
                    <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M55.8 0H6.2C2.79 0 0 2.79 0 6.2V62L12.4 49.6H55.8C59.21 49.6 62 46.81 62 43.4V6.2C62 2.79 59.21 0 55.8 0Z" fill="#F6F4EB"/>
                    </svg>
                </div>
                <div class="inner-box">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 12C15.3 12 18 9.3 18 6C18 2.7 15.3 0 12 0C8.7 0 6 2.7 6 6C6 9.3 8.7 12 12 12ZM12 15C7.95 15 0 16.95 0 21V24H24V21C24 16.95 16.05 15 12 15Z" :fill="data.impairedRegime ? 'rgba(0,0,0,0.6)' : '#568357'"/>
                    </svg>
                </div>
                <span v-if="lang === 'ru'" :style="{ 'color' : data.impairedRegime ? '#ffffff' : '#F6F4EB'}">Задать анонимный вопрос</span>
                <span v-if="lang === 'kk'" :style="{ 'color' : data.impairedRegime ? '#ffffff' : '#F6F4EB'}">Анонимді сұрақ қою</span>
            </div>
        </div>
        <div class="foot-bottom">
            <div :style="{ 'background' : data.impairedRegime ? '#ffffff' : '#568357', 'color' : data.impairedRegime ? '#000000' : '#FFFFFF'}" class="foot-main flex-col">
                <div class="up-section flex-col">
                    <h3 v-if="lang === 'ru'">Не упусти важные новости</h3>
                    <h3 v-if="lang === 'kk'">Маңызды жаңалықтардан ұдайы хабардар болыңыз</h3>
                    <span v-if="lang === 'ru'">Подпишись на email рассылки, чтобы всегда быть в курсе</span>
                    <span v-if="lang === 'kk'">"Әркез хабардар болу үшін e-mail хабарламаларға жазылыңыз"</span>
                    <div v-if="lang === 'ru'" class="flex-row">
                        <input v-model="mail" v-on:keyup="validateForm($event)" :style="{ 'border-color' : data.impairedRegime ? 'rgba(0,0,0,0.6)' : '#568357' }" name="mail" type="text" maxlength="30" placeholder="Введите email адрес">
                        <div class="button" :style="{ 'background' : data.impairedRegime ? 'rgba(0,0,0,0.6)' : '#F0DCC4', 'color' : data.impairedRegime ? '#ffffff' : '#568357' }" @click="subscribe()">Отправить</div>
                    </div>
                    <div v-if="lang === 'kk'" class="flex-row">
                        <input v-model="mail" v-on:keyup="validateForm($event)" :style="{ 'border-color' : data.impairedRegime ? 'rgba(0,0,0,0.6)' : '#568357' }" name="mail" type="text" maxlength="30" placeholder="Электронды поштаны жазу">
                        <div class="button" :style="{ 'background' : data.impairedRegime ? 'rgba(0,0,0,0.6)' : '#F0DCC4', 'color' : data.impairedRegime ? '#ffffff' : '#568357' }" @click="subscribe()">Жіберу</div>
                    </div>
                </div>
                <div class="sep-line"></div>
                <div class="low-section flex-col">
                    <div class="top flex-row">
                        <div class="icon flex-row">
                            <img v-if="data.impairedRegime" :style="{ 'filter' : 'grayscale(1)', '-webkit-filter' : 'grayscale(1)' }" data-src="/media/footer-logo.png" alt="" class="lazyload">
                            <img v-else data-src="/media/footer-logo.png" alt="" class="lazyload">
                        </div>
                        <span v-if="lang === 'ru'" class="name">если честно...</span>
                        <span v-if="lang === 'kk'" class="name">шынымен айтқанда...</span>
                    </div>
                    <div v-if="lang === 'ru'" class="sub-text">
                        Проект реализован Министерством здравоохранения Республики Казахстан при финансовой и технической поддержке Фонда ООН в области народонаселения (ЮНФПА) в Казахстане и активном содействии наших партнеров: Казахского научного центра дерматологии и инфекционных заболеваний, Национального центра общественного здравоохранения. С 2022 года реализация проекта Shyn.kz осуществляется  ОФ “Focus on People Foundation” при поддержке Фонда ООН в области народонаселения (ЮНФПА) в Казахстане.
                    </div>
                    <div v-if="lang === 'kk'" class="sub-text">
                        Жобаны БҰҰ-ның Халық қоныстану қорының (ЮНФПА) қаржылық және техникалық қолдауымен және серіктестеріміздің: Қазақ дерматология және инфекциялық аурулар ғылыми орталығы, Қоғамдық денсаулық сақтау ұлттық орталығының белсенді көмегі арқылы Қазақстан Республикасының Денсаулық сақтау министрлігі жүзеге асырды. 2022-ші жылдан бастап Shyn.kz жобасын “Focus on People Foundation” Қоғамдық қоры БҰҰ-ның Қазақстандағы Халық қоныстану қорының (ЮНФПА) көмегімен жалғастыруда.
                    </div>
                    <div class="content flex-row">
                        <div class="contact flex-col">
                            <a v-if="lang === 'ru'" href="/media/Согласие на обработку данных.docx" class="text">Согласие на обработку данных</a>
                            <a v-if="lang === 'kk'" href="/media/Согласие на обработку данных.docx" class="text">Мәліметтерді өңдеуге келісім</a>
                            <a href="tel:87029466996" class="phone">8 702 946 69 96</a>
                            <a class="mail">fpf.kaz@gmail.com г. Алматы, Орбита-1, дом 1</a>
                        </div>
                        <div class="menu flex-col">
                            <a v-if="lang === 'ru'" @click="$router.push({ name: 'about' })">О проекте</a>
                            <a v-if="lang === 'kk'" @click="$router.push({ name: 'about' })">Жоба жайлы</a>
                            <a v-if="lang === 'ru'" @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'mybody' } })">Рубрики</a>
                            <a v-if="lang === 'kk'" @click="$router.push({ name: 'rubric', query: { rubric: 'girls', sub: 'mybody' } })">Айдарлар</a>
                            <a v-if="lang === 'ru'" @click="$router.push({ name: 'faq' });  window.scrollTo(0,0)">Вопросы и ответы</a>
                            <a v-if="lang === 'kk'" @click="$router.push({ name: 'faq' });  window.scrollTo(0,0)">Сұрақтар мен жауаптар</a>
                            <a v-if="lang === 'ru'" @click="$router.push({ name: 'contact' })">Контакты</a>
                            <a v-if="lang === 'kk'" @click="$router.push({ name: 'contact' })">Байланыстар</a>
                        </div>
                        <div class="follow flex-col">
                            <span v-if="lang === 'ru'" class="text">Следи за нами</span>
                            <span v-if="lang === 'kk'" class="text">Бізге жазылып қой</span>
                            <div class="socials flex-row">
                                <a href="https://vt.tiktok.com/ZSdgMWsAe/" :style="{ 'border-color' : data.impairedRegime ? '#000000' : '#D3DCE6' }" style="padding: 3.5px 9px 0.5px 9px" class="icon-social">
                                    <svg width="16" height="16" viewBox="0 0 512 512" id="icons" xmlns="http://www.w3.org/2000/svg"><path d="M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z"/></svg>
                                </a>
                                <a href="https://instagram.com/shyn.kz?igshid=YmMyMTA2M2Y=" :style="{ 'border-color' : data.impairedRegime ? '#000000' : '#D3DCE6' }" style="padding: 4px 7px 0px 7px" class="icon-social">
                                    <svg width="16" height="17" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.1455 5.13777C12.6757 5.13777 13.1055 4.70797 13.1055 4.17777C13.1055 3.64758 12.6757 3.21777 12.1455 3.21777C11.6154 3.21777 11.1855 3.64758 11.1855 4.17777C11.1855 4.70797 11.6154 5.13777 12.1455 5.13777Z" fill="white"/>
                                        <path d="M8 12.2861C5.794  12.2861 4 10.4921 4 8.28613C4 6.08013 5.794 4.28613 8 4.28613C10.206 4.28613 12 6.08013 12 8.28613C12 10.4921 10.206 12.2861 8 12.2861ZM8 6.28613C6.897 6.28613 6 7.18313 6 8.28613C6 9.38913 6.897 10.2861 8 10.2861C9.103 10.2861 10 9.38913 10 8.28613C10 7.18313 9.103 6.28613 8 6.28613Z" :fill="data.impairedRegime ? '#000000' : 'white'"/>
                                        <path d="M12 16.2861H4C1.944 16.2861 0 14.3421 0 12.2861V4.28613C0 2.23013 1.944 0.286133 4 0.286133H12C14.056 0.286133 16 2.23013 16 4.28613V12.2861C16 14.3421 14.056 16.2861 12 16.2861ZM4 2.28613C3.065 2.28613 2 3.35113 2 4.28613V12.2861C2 13.2391 3.047 14.2861 4 14.2861H12C12.935 14.2861 14 13.2211 14 12.2861V4.28613C14 3.35113 12.935 2.28613 12 2.28613H4Z" :fill="data.impairedRegime ? '#000000' : 'white'"/>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="bottom">
                        <span v-if="lang === 'ru'">2020 © shyn.kz. Все права защищены</span>
                        <span v-if="lang === 'kk'">2020 © shyn.kz. Барлық құқықтары сақталған</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'

export default {
    props: [ 'data' ],
    data(){
        return {
            mail: '',
            lang: 'kk'
        }
    },
    created(){
        if( localStorage.getItem('xyzCustomLang') ){
			this.lang = localStorage.getItem('xyzCustomLang')
			window.lang = this.lang
		}
    },
    methods:{
        validateForm(e){
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if(e.target.name === 'mail'){
                if (!pattern.test(String(e.target.value).toLowerCase())) {
                    e.srcElement.classList.add('error')
                } else {
                    e.srcElement.classList.remove('error')
                }
            }
        },
        subscribe(){
            if(this.mail === ''){
                document.getElementsByName('mail')[0].classList.add('error')
            }
            if(document.getElementsByClassName('error').length !== 0) return 
            const data = {
                "Email": this.mail
            }
            axios.post( 'https://shyn.kz/mail/send?type=subscription', data, {
                headers: {
                    "Access-Control-Allow-Origin": '*'
                }
             })
            .then((res) => {
                console.log(res.data)
                alert("Thanks for subscription.")
            })  
            .catch((e) => {
                alert(e);
                console.log('Error in loading news\n' + e)
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    span, h3{
        cursor: default;
    }
    .outer{
        position: relative;
        bottom: 0;
        height: 990px;
        background: #F2F2F2;
        .foot-top{
            background: #FFFFFF;
            border-top-left-radius: 200px;
            height: 170px;
            padding: 24px 16% 36px 16%;
            h3, span{
                text-align: left;
                margin-top: 20px;
                font-weight: 500;
                letter-spacing: 0.05em;
            }
            h3{
                font-size: 36px;
                line-height: 46px;
                margin-bottom: 0px;
            }
            span{
                width: 400px;
                font-size: 16px;
                line-height: 26px;
                display: flex;
                align-items: center;
            }
            .q-box{
                cursor: pointer;
                position: absolute;
                right: 16%;
                height: 170px;
                width: 232px;
                box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                border-radius: 10px;
                .out-box, .inner-box{
                    position: relative;
                    width: 100%;
                    text-align: center;
                }
                .out-box{
                    top: 34px;
                    height: 62px;
                }
                .inner-box{
                    top: -15px;
                    height: 24px;
                }
                span{
                    width: 100%;
                    cursor: pointer;
                    font-weight: 500;
                    font-size: 20px;
                    line-height: 25px;
                    display: flex;
                    align-items: center;
                    text-align: center;
                    letter-spacing: 0.05em;
                }
            }
        }
        .foot-bottom{
            height: 761px;
            background: #FFFFFF;
            .foot-main{
                height: 761px;
                border-top-right-radius: 200px;
                .up-section{
                    padding: 50px 20% 50px 16%;
                    h3, span{
                        text-align: left;
                        letter-spacing: 0.05em;
                        font-weight: 500;
                    }
                    h3{
                        font-size: 36px;
                        line-height: 46px;
                        margin-top: 0;
                        margin-bottom: 0px;
                    }
                    span{
                        margin-top: 15px;
                        font-size: 16px;
                        line-height: 26px;
                        opacity: 0.6;
                    }
                    div{
                        position: relative;
                        margin-top: 25px;
                        height: 72px;
                        input{
                            border-top-left-radius: 10px;
                            border-bottom-left-radius: 10px;
                            width: calc(100% - 304px);
                            border: 1px solid #568357;
                            height: 30px;
                            background: #FFFFFF;
                            font-weight: 300;
                            font-size: 16px;
                            line-height: 30px;
                            padding: 20px 42px;
                            letter-spacing: 0.04em;
                        }
                        input::placeholder{
                            opacity: 0.6;
                        }
                        .error{
                            border: 1px solid #E4002F !important;
                            box-shadow: 6px 6px 10px rgba(228, 0, 47, 0.2) !important;
                        }
                        .button{
                            margin: 0;
                            cursor: pointer;
                            border-top-right-radius: 10px;
                            border-bottom-right-radius: 10px;
                            border: none;
                            width: 220px;
                            height: 24px;
                            position: absolute;
                            right: 0;
                            padding: 24px 0; 
                            font-weight: 500;
                            font-size: 20px;
                            line-height: 26px;
                            text-align: center;
                            letter-spacing: 0.04em;
                        }
                    }
                }
                .sep-line{
                    position: relative;
                    opacity: 0.4;
                    background: #FFFFFF;
                    height: 1px;
                    min-height: 1px;
                    right: 20%;
                }
                .low-section{
                    padding: 41px 20% 0px 16%;
                    .top{
                        position: relative;
                        .icon{
                            position: relative;
                            top: 0;
                            width: 48px;
                            height: 48px;
                            background: #FFFFFF;
                            border-radius: 50%;
                            img{
                                position: absolute;
                                transform: scale(0.25) translateX(-140%) translateY(-135%);
                            }  
                        }
                        .name{
                            margin-left: 16px;
                            font-weight: 500;
                            font-size: 28px;
                            line-height: 46px;
                            letter-spacing: 0.02em;
                        }
                    }
                    .sub-text{
                        cursor: default;
                        margin-top: 16px;
                        text-align: left;
                        font-weight: 300;
                        font-size: 14px;
                        line-height: 26px;
                        letter-spacing: 0.05em;
                    }
                    .content{
                        margin-top: 30px;
                        position: relative;
                        a{
                            text-align: left;
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 26px;
                            letter-spacing: 0.05em;
                            cursor: pointer;
                            text-decoration: none;
                        }
                        .contact{
                            a{
                                margin-bottom: 24px;
                            }
                        }
                        .menu{
                            margin-left: 12%;
                            a{
                                margin-top: 16px;
                            }
                            a:first-of-type{
                                margin-top: 0;
                            }
                        }
                        .follow{
                            position: absolute;
                            right: 0;
                            width: 214px;
                            .text{
                                opacity: 0.5;
                            }
                            .socials{
                                margin-top: 72px;
                                .icon-social{
                                    cursor: pointer;
                                    text-decoration: none;
                                    border: 1px solid #D3DCE6;
                                    box-sizing: border-box;
                                    border-radius: 5px;
                                    margin-left: 20px;
                                }
                                .icon-social:first-of-type{
                                    margin-left: 0;
                                }
                            }
                        }
                    }
                    .bottom{
                        text-align: left;
                        margin-top: 60px;
                        span{
                            text-align: left;
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 26px;
                            letter-spacing: 0.05em;
                            opacity: 0.4;
                        }
                    }
                }
            }
        }
    }
    @media only screen and (max-width: 1240px){
        .outer{
            height: 960px;
            .foot-top{
                padding: 34px 10% 36px 10%;
                h3{
                    font-size: 32px;
                    line-height: 32px;
                }
                span{
                    line-height: 24px;
                }
            }
            .foot-bottom{
                height: 731px;
                .foot-main{
                    height: 731px;
                    .up-section{
                        padding: 40px 12% 40px 10%;
                        h3{
                            font-size: 32px;
                            line-height: 32px;
                        }
                    }
                    .sep-line{
                        right: 12%;
                    }
                    .low-section{
                        padding: 30px 12% 0px 10%;
                        .top{
                            .name{
                                font-size: 26px;
                            }
                        }
                        .content{
                            .menu{
                                margin-left: 8%;
                            }
                        }
                    }
                }
            }
        } 
    }
    @media only screen and (max-width: 940px){
        .outer{
            height: 870px;
            .foot-top{
                border-top-left-radius: 120px;
                height: 120px;
                padding: 24px 8% 34px 8%;
                h3{
                    font-weight: 800;
                    font-size: 20px;
                    line-height: 26px;
                }
                span{
                    width: 330px;
                    font-size: 16px;
                    line-height: 18px;
                }
                .q-box{
                    right: 10%;
                    height: 130px;
                    width: 150px;
                    .out-box{
                        top: 14px;
                        height: 42px;
                    }
                    .inner-box{
                        top: -14px;
                        height: 24px;
                    }
                    span{
                        font-size: 14px;
                        line-height: 18px;
                    }
                }
            }
            .foot-bottom{
                height: 691px;
                .foot-main{
                    border-top-right-radius: 120px;
                    height: 691px;
                    .up-section{
                        padding: 30px 8% 30px 8%;
                        h3{
                            font-size: 24px;
                            line-height: 32px;
                        }
                        span{
                            margin-top: 10px;
                        }
                        div{
                            margin-top: 15px;
                            input{
                                width: calc(100% - 202px);
                                height: 46px;
                                padding: 12px 21px;
                            }
                            .button{
                                width: 160px;
                            }
                        }
                    }
                    .sep-line{
                        right: 8%;
                    }
                    .low-section{
                        padding: 30px 8% 0px 8%;
                        .top{
                            .name{
                                text-align: left;
                                font-size: 22px;
                            }
                        }
                        .content{
                            .text, a{
                                font-size: 14px;
                            }
                            .menu{
                                display: none;
                            }
                        }
                        .bottom{
                            margin-top: 40px;
                        }
                    }
                }
            }
        } 
    }
    @media only screen and (max-width: 750px){
        .outer{
            height: 960px;
            .foot-bottom{
                height: 781px;
                .foot-main{
                    height: 781px;
                }
            }
        } 
    }
    @media only screen and (max-width: 560px){
        .outer{
            height: 770px;
            .foot-top{
                border-top-left-radius: 60px;
                padding: 10px 8% 30px 8%;
                h3{
                    width: 240px;
                    margin-top: 4px;
                    font-weight: 800;
                    font-size: 16px;
                    line-height: 18px;
                }
                span{
                    margin-top: 20px;
                    width: 200px;
                    font-size: 12px;
                    line-height: 14px;
                }
                .q-box{
                    right: 8%;
                    height: 100px;
                    width: 100px;
                    .out-box{
                        top: 0px;
                        height: 12px;
                        svg{
                            transform: scale(0.5)
                        }
                    }
                    .inner-box{
                        top: 2px;
                        height: 28px;
                        transform: scale(0.6)
                    }
                    span{
                        margin-top: 10px;
                        font-size: 14px;
                        line-height: 14px;
                    }
                }
            }
            .foot-bottom{
                height: 651px;
                .foot-main{
                    border-top-right-radius: 60px;
                    height: 651px;
                    .up-section{
                        padding: 20px 8% 20px 8%;
                        h3{
                            display: none;
                        }
                        span{
                            margin-top: 0px;
                            line-height: 22px;
                        }
                        div{
                            flex-direction: column;
                            margin-top: 15px;
                            input{
                                width: calc(100% - 42px);
                                height: 46px;
                                padding: 16px 21px;
                                border-radius: 10px;
                            }
                            .button{
                                margin-top: 10px;
                                padding: 13px 0;
                                border-radius: 10px;
                                position: relative;
                                width: 100%;
                            }
                        }
                    }
                    .sep-line{
                        margin-top: 46px;
                        right: 8%;
                    }
                    .low-section{
                        padding: 20px 8% 0px 8%;
                        .top{
                            .name{
                                text-align: left;
                                font-size: 14px;
                                font-weight: 800;
                            }
                        }
                        .sub-text{
                            line-height: 20px;
                        }
                        .content{
                            .text, a{
                                font-size: 14px;
                                line-height: 18px;
                            }
                            .contact{
                                display: none;
                            }
                            .follow{
                                width: 100%;
                                position: relative;
                                .text{
                                    display: none;
                                }
                                .socials{
                                    margin-top: 0px;
                                    .icon-social{
                                        margin-left: calc(25% - 32px);
                                        line-height: 26px;
                                    }
                                    .icon-social:first-of-type{
                                        margin-left: 0;
                                    }
                                }
                            }
                        }
                        .bottom{
                            margin-top: 30px;
                        }
                    }
                }
            }
        } 
    }
    @media only screen and (max-width: 380px){
        .outer{
            height: 780px;
            .foot-top{
                border-top-left-radius: 40px;
                padding: 10px 4% 30px 4%;
                .q-box{
                    right: 4%;
                }
            }
            .foot-bottom{
                height: 661px;
                .foot-main{
                    border-top-right-radius: 40px;
                    height: 661px;
                    .up-section{
                        padding: 20px 4% 20px 4%;
                    }
                    .sep-line{
                        right: 4%;
                    }
                    .low-section{
                        padding: 20px 4% 0px 4%;
                    }
                }
            }
        } 
    }
</style>
